import { RecruiterGuestView } from '../page-components/Recruiiter/RecruiterGuestView';

import Connection from './../connection/Connection';

export default RecruiterGuestView;

export const getServerSideProps = async () => {
  const connection = Connection.nextConnectionNoAuth();
  try {
    const topHiringdata = await connection.get('home/landing');
    const currencydata = await connection.get(`home/currency/${'USD'}`);
    //const guestdata = await connection.get('home/candidate', { active: true });
    const data = {
      guestData: topHiringdata.testimonials,
      topHiring: topHiringdata.topHiring,
      currency: currencydata.exRate,
    };
    return { props: { data } };
  } catch (e) {
    return {
      props: {},
    };
  }
};
